import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import PosologiaModel from "@/models/posologiaModel";
import posologiaService from "@/services/posologiaService";

import ListComponentBase from "../listComponentBase";

import "../crud.scss";

@Component
export default class PosologiaListComponent extends ListComponentBase<PosologiaModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("id", "Código", GridColumnType.Integer),
            new GridColumn("descricao", "Descri\u00e7\u00e3o", GridColumnType.String),
            new GridColumn("dose", "Doses por semana", GridColumnType.Integer),
        ];
    }

    private beforeMount() {
        this.setProps(posologiaService, "posologia", "descricao");
    }
}
